import { range } from '@finect/front-utils/range';
export var getYearsFromNow = function getYearsFromNow() {
  var numYears = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  var orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
  var years = range(numYears, new Date().getFullYear() - numYears);
  return orderBy === 'asc' ? years : years.reverse();
};